export function ProvenanceChip({
  text,
  compact,
  full,
  title,
}: {
  text: string;
  /** Hard-cap at 180px — for chips inside dense table cells. */
  compact?: boolean;
  /** No pixel cap — fills the container (metal-accounting section provenance). */
  full?: boolean;
  /** Hover text when `text` is a plain-word label on the glass. Defaults to `text`. */
  title?: string;
}) {
  if (!text) return null;
  const tooltip = title ?? text;
  const maxWidth = full ? 'max-w-full' : compact ? 'max-w-[180px]' : 'max-w-[300px]';
  return (
    <span
      title={tooltip}
      className={`inline-block ${maxWidth} truncate rounded-full border border-[var(--glass-border)] px-2 py-0.5 text-xs text-[var(--ink-secondary)] dark:text-zinc-300`}
    >
      {text}
    </span>
  );
}
